module.exports = __webpack_public_path__ + "static/media/redux.5a002f89.svg";